import inflatableLips from "../../images/Paintings/Peoplescapes_2018-2023/1_inflatableLips.jpg";
import strangeParadise4 from "../../images/Paintings/Peoplescapes_2018-2023/79_strangeParadise4.jpg";
import chelseaNyc from "../../images/Paintings/Peoplescapes_2018-2023/86_chelseaNYC.jpg" ;

import soho2053 from "../../images/Paintings/Peoplescapes_2018-2023/93_soho2053.jpg" ;
import thredbo4 from "../../images/Paintings/Peoplescapes_2018-2023/90_thredbo4.jpg" ;
import newYorkersSpring from "../../images/Paintings/Peoplescapes_2018-2023/96_newYorkersSpring.jpg" ;
import newYorkersSummer from "../../images/Paintings/Peoplescapes_2018-2023/97_newYorkersSummer.jpg" ;
import newYorkersFall from "../../images/Paintings/Peoplescapes_2018-2023/95_newYorkersFall.jpg" ;
import newYorkersWinter from "../../images/Paintings/Peoplescapes_2018-2023/88_newYorkersWinter.jpg" ;
import redfern from "../../images/Paintings/Peoplescapes_2018-2023/2_redfern.jpg";
import manly3 from "../../images/Paintings/Peoplescapes_2018-2023/3_manly3.jpg";
import theInterview6 from "../../images/Paintings/Peoplescapes_2018-2023/4_theInterview6.jpg";
import theInterviewDetail from "../../images/Paintings/Peoplescapes_2018-2023/5_theInterviewDetail.jpg";
import campCove from "../../images/Paintings/Peoplescapes_2018-2023/6_campCove.jpg";
import woollahra2 from "../../images/Paintings/Peoplescapes_2018-2023/7_woollahra2.jpg";
import paddo from "../../images/Paintings/Peoplescapes_2018-2023/8_paddo.jpg";
import october from "../../images/Paintings/Peoplescapes_2018-2023/9_october.jpg";
import mtBuller from "../../images/Paintings/Peoplescapes_2018-2023/10_mtBuller.jpg";
import justHangingAround from "../../images/Paintings/Peoplescapes_2018-2023/82_justHangingAround.jpg";
import overcast from "../../images/Paintings/Peoplescapes_2018-2023/11_overcast.jpg";
import springStreet from "../../images/Paintings/Peoplescapes_2018-2023/81_springSt.jpg";
import jazzInPark2 from "../../images/Paintings/Peoplescapes_2018-2023/13_jazzInPark2.jpg";
import strangeParadise3 from "../../images/Paintings/Peoplescapes_2018-2023/14_strangeParadise3.jpg";
import theRestaurant from "../../images/Paintings/Peoplescapes_2018-2023/15_theRestaurant.jpg";
import richmond from "../../images/Paintings/Peoplescapes_2018-2023/16_richmond.jpg";
import thredbo from "../../images/Paintings/Peoplescapes_2018-2023/17_thredbo.jpg";
import paris from "../../images/Paintings/Peoplescapes_2018-2023/18_paris.jpg";
import pinkAfternoon from "../../images/Paintings/Peoplescapes_2018-2023/19_pinkAfternoon.jpg";
import marbleArch from "../../images/Paintings/Peoplescapes_2018-2023/20_marbleArch.jpg";
import hamsteadHeath from "../../images/Paintings/Peoplescapes_2018-2023/21_hamsteadHeath.jpg";
import ottawa from "../../images/Paintings/Peoplescapes_2018-2023/22_ottawa.jpg";
import bondiSummers7 from "../../images/Paintings/Peoplescapes_2018-2023/23_bondiSummers7.jpg";
import aDayInAnnadale from "../../images/Paintings/Peoplescapes_2018-2023/24_aDayInAnnadale.jpg";
import eastVillage from "../../images/Paintings/Peoplescapes_2018-2023/25_eastVillage.jpg";
import newYorkJune from "../../images/Paintings/Peoplescapes_2018-2023/91_juneNewYork.jpg";
import kuttiBeach2 from "../../images/Paintings/Peoplescapes_2018-2023/26_kuttiBeach2.jpg";
import manly2 from "../../images/Paintings/Peoplescapes_2018-2023/27_manly2.jpg";
import campCoveDetail from "../../images/Paintings/Peoplescapes_2018-2023/28_campCoveDetail.jpg";
import surryHills from "../../images/Paintings/Peoplescapes_2018-2023/29_surryHills.jpg";
import castingCall from "../../images/Paintings/Peoplescapes_2018-2023/30_castingCall.jpg";
import protestsDowntown from "../../images/Paintings/Peoplescapes_2018-2023/31_protestsDowntown.jpg";
import theFilmSet from "../../images/Paintings/Peoplescapes_2018-2023/32_theFilmSet.jpg";
import moonlightBeach from "../../images/Paintings/Peoplescapes_2018-2023/33_moonlightBeach.jpg";
import sydney4 from "../../images/Paintings/Peoplescapes_2018-2023/34_sydney4.jpg";
import les from "../../images/Paintings/Peoplescapes_2018-2023/35_les.jpg";
import castingCall2 from "../../images/Paintings/Peoplescapes_2018-2023/36_castingCall2.jpg";
import zermatt from "../../images/Paintings/Peoplescapes_2018-2023/37_zermatt.jpg";
import theInterview from "../../images/Paintings/Peoplescapes_2018-2023/38_theInterview.jpg";
import theBusStop5 from "../../images/Paintings/Peoplescapes_2018-2023/87_busStop5.jpg";
import burleighHeads from "../../images/Paintings/Peoplescapes_2018-2023/84_burleighHeads.jpg";
import northLondon from "../../images/Paintings/Peoplescapes_2018-2023/39_northLondon.jpg";
import summerHolidays from "../../images/Paintings/Peoplescapes_2018-2023/40_summerHolidays.jpg";
import forFiveLA from "../../images/Paintings/Peoplescapes_2018-2023/41_forFiveLA.jpeg";
import darlinghurst from "../../images/Paintings/Peoplescapes_2018-2023/42_darlinghurst.jpg";
import cityOfAngels from "../../images/Paintings/Peoplescapes_2018-2023/43_cityOfAngels.jpg";
import theBusStop2 from "../../images/Paintings/Peoplescapes_2018-2023/44_theBusStop2.jpg";
import greenpoint from "../../images/Paintings/Peoplescapes_2018-2023/45_greenpoint.jpg";
import princeSt from "../../images/Paintings/Peoplescapes_2018-2023/46_princeSt.jpg";
import east69thSt from "../../images/Paintings/Peoplescapes_2018-2023/47_east69thSt.jpg";
import bondSt from "../../images/Paintings/Peoplescapes_2018-2023/48_bondSt.jpg";
import bondStDetail from "../../images/Paintings/Peoplescapes_2018-2023/49_bondStDetail.jpg";
import greeneSt from "../../images/Paintings/Peoplescapes_2018-2023/89_greeneSt.jpg";
import losAngeles from "../../images/Paintings/Peoplescapes_2018-2023/50_losAngeles.jpg";
import pointKint from "../../images/Paintings/Peoplescapes_2018-2023/51_pointKint.jpg";
import fiDi2 from "../../images/Paintings/Peoplescapes_2018-2023/52_fiDi2.jpg";
import aDayinPaddo3 from "../../images/Paintings/Peoplescapes_2018-2023/53_aDayinPaddo3.jpg";
import studio2019 from "../../images/Paintings/Peoplescapes_2018-2023/54_studio2019.jpg";
import bondiIcebergs from "../../images/Paintings/Peoplescapes_2018-2023/55_bondiIcebergs.jpg";
import sydney3 from "../../images/Paintings/Peoplescapes_2018-2023/56_sydney3.jpg";
import cobbleHill from "../../images/Paintings/Peoplescapes_2018-2023/80_cobbleHill.JPG";
import sandringhamBeach from "../../images/Paintings/Peoplescapes_2018-2023/98_sandringhamBeach.jpg";
import tamarama from "../../images/Paintings/Peoplescapes_2018-2023/57_tamarama.jpg";
import paddington6 from "../../images/Paintings/Peoplescapes_2018-2023/58_paddington6.jpg";
import aDayInChipenndale from "../../images/Paintings/Peoplescapes_2018-2023/59_aDayInChipenndale.jpg";
import snowDayWilliamsburg from "../../images/Paintings/Peoplescapes_2018-2023/60_snowDayWilliamsburg.jpg";
import skiApres from "../../images/Paintings/Peoplescapes_2018-2023/61_skiApres.jpg";
import sandyBay from "../../images/Paintings/Peoplescapes_2018-2023/62_sandyBay.jpg";
import london from "../../images/Paintings/Peoplescapes_2018-2023/63_london.jpg";
import toorak from "../../images/Paintings/Peoplescapes_2018-2023/64_toorak.jpg";
import aDayInWoolahra from "../../images/Paintings/Peoplescapes_2018-2023/65_aDayInWoolahra.jpg";
import paddington4 from "../../images/Paintings/Peoplescapes_2018-2023/66_paddington4.jpg";
import madisonAve from "../../images/Paintings/Peoplescapes_2018-2023/67_madisonAve.jpg";
import theOptimist from "../../images/Paintings/Peoplescapes_2018-2023/68_theOptimist.jpg";
import broadway from "../../images/Paintings/Peoplescapes_2018-2023/69_broadway.jpg";
import snowDayNYC from "../../images/Paintings/Peoplescapes_2018-2023/70_snowDayNYC.jpg";
import bleeckerStStation from "../../images/Paintings/Peoplescapes_2018-2023/71_bleeckerStStation.jpg";
import amsterdam from "../../images/Paintings/Peoplescapes_2018-2023/72_amsterdam.jpg";
import paddington7 from "../../images/Paintings/Peoplescapes_2018-2023/73_paddington7.jpg";
import betootaHeights from "../../images/Paintings/Peoplescapes_2018-2023/74_betootaHeights.jpg";
import bronte from "../../images/Paintings/Peoplescapes_2018-2023/75_bronte.jpg";
import washingtonDC from "../../images/Paintings/Peoplescapes_2018-2023/76_washingtonDC.jpg";
import familyVacation3 from "../../images/Paintings/Peoplescapes_2018-2023/77_familyVacation3.jpg";
import middlePark from "../../images/Paintings/Peoplescapes_2018-2023/78_middlePark.jpg";
import prospectPark from "../../images/Paintings/Peoplescapes_2018-2023/85_prospectPark.jpg";

// 800px responsive versions for srcset
import inflatableLipsSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/1_inflatableLips.jpg";
import strangeParadise4Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/79_strangeParadise4.jpg";
import chelseaNycSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/86_chelseaNYC.jpg";
import soho2053Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/93_soho2053.jpg";
import thredbo4Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/90_thredbo4.jpg";
import newYorkersSpringSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/96_newYorkersSpring.jpg";
import newYorkersSummerSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/97_newYorkersSummer.jpg";
import newYorkersFallSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/95_newYorkersFall.jpg";
import newYorkersWinterSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/88_newYorkersWinter.jpg";
import redfernSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/2_redfern.jpg";
import manly3Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/3_manly3.jpg";
import theInterview6Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/4_theInterview6.jpg";
import theInterviewDetailSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/5_theInterviewDetail.jpg";
import campCoveSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/6_campCove.jpg";
import woollahra2Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/7_woollahra2.jpg";
import paddoSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/8_paddo.jpg";
import octoberSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/9_october.jpg";
import mtBullerSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/10_mtBuller.jpg";
import justHangingAroundSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/82_justHangingAround.jpg";
import overcastSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/11_overcast.jpg";
import springStreetSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/81_springSt.jpg";
import jazzInPark2Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/13_jazzInPark2.jpg";
import strangeParadise3Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/14_strangeParadise3.jpg";
import theRestaurantSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/15_theRestaurant.jpg";
import richmondSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/16_richmond.jpg";
import thredboSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/17_thredbo.jpg";
import parisSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/18_paris.jpg";
import pinkAfternoonSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/19_pinkAfternoon.jpg";
import marbleArchSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/20_marbleArch.jpg";
import hamsteadHeathSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/21_hamsteadHeath.jpg";
import ottawaSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/22_ottawa.jpg";
import bondiSummers7Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/23_bondiSummers7.jpg";
import aDayInAnnadaleSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/24_aDayInAnnadale.jpg";
import eastVillageSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/25_eastVillage.jpg";
import newYorkJuneSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/91_juneNewYork.jpg";
import kuttiBeach2Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/26_kuttiBeach2.jpg";
import manly2Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/27_manly2.jpg";
import campCoveDetailSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/28_campCoveDetail.jpg";
import surryHillsSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/29_surryHills.jpg";
import castingCallSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/30_castingCall.jpg";
import protestsDowntownSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/31_protestsDowntown.jpg";
import theFilmSetSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/32_theFilmSet.jpg";
import moonlightBeachSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/33_moonlightBeach.jpg";
import sydney4Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/34_sydney4.jpg";
import lesSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/35_les.jpg";
import castingCall2Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/36_castingCall2.jpg";
import zermattSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/37_zermatt.jpg";
import theInterviewSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/38_theInterview.jpg";
import theBusStop5Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/87_busStop5.jpg";
import burleighHeadsSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/84_burleighHeads.jpg";
import northLondonSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/39_northLondon.jpg";
import summerHolidaysSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/40_summerHolidays.jpg";
import forFiveLASm from "../../images/Paintings/Peoplescapes_2018-2023/sm/41_forFiveLA.jpg";
import darlinghurstSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/42_darlinghurst.jpg";
import cityOfAngelsSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/43_cityOfAngels.jpg";
import theBusStop2Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/44_theBusStop2.jpg";
import greenpointSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/45_greenpoint.jpg";
import princeStSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/46_princeSt.jpg";
import east69thStSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/47_east69thSt.jpg";
import bondStSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/48_bondSt.jpg";
import bondStDetailSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/49_bondStDetail.jpg";
import greeneStSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/89_greeneSt.jpg";
import losAngelesSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/50_losAngeles.jpg";
import pointKintSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/51_pointKint.jpg";
import fiDi2Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/52_fiDi2.jpg";
import aDayinPaddo3Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/53_aDayinPaddo3.jpg";
import studio2019Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/54_studio2019.jpg";
import bondiIcebergsSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/55_bondiIcebergs.jpg";
import sydney3Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/56_sydney3.jpg";
import cobbleHillSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/80_cobbleHill.jpg";
import sandringhamBeachSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/98_sandringhamBeach.jpg";
import tamaramaSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/57_tamarama.jpg";
import paddington6Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/58_paddington6.jpg";
import aDayInChipenndaleSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/59_aDayInChipenndale.jpg";
import snowDayWilliamsburgSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/60_snowDayWilliamsburg.jpg";
import skiApresSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/61_skiApres.jpg";
import sandyBaySm from "../../images/Paintings/Peoplescapes_2018-2023/sm/62_sandyBay.jpg";
import londonSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/63_london.jpg";
import toorakSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/64_toorak.jpg";
import aDayInWoolahraSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/65_aDayInWoolahra.jpg";
import paddington4Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/66_paddington4.jpg";
import madisonAveSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/67_madisonAve.jpg";
import theOptimistSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/68_theOptimist.jpg";
import broadwaySm from "../../images/Paintings/Peoplescapes_2018-2023/sm/69_broadway.jpg";
import snowDayNYCSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/70_snowDayNYC.jpg";
import bleeckerStStationSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/71_bleeckerStStation.jpg";
import amsterdamSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/72_amsterdam.jpg";
import paddington7Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/73_paddington7.jpg";
import betootaHeightsSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/74_betootaHeights.jpg";
import bronteSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/75_bronte.jpg";
import washingtonDCSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/76_washingtonDC.jpg";
import familyVacation3Sm from "../../images/Paintings/Peoplescapes_2018-2023/sm/77_familyVacation3.jpg";
import middleParkSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/78_middlePark.jpg";
import prospectParkSm from "../../images/Paintings/Peoplescapes_2018-2023/sm/85_prospectPark.jpg";

const peopleScapes2023Collection = [
  {
    image: inflatableLips,
    imageSm: inflatableLipsSm,
    title: "Inflatable Lips and a Popsicle",
    description: "Oil & acrylic on linen. 76cm x 76cm. 2022",
    alt: "Inflatable Lips and a Popsicle. Oil & acrylic on linen. 76cm x 76cm. 2022",
  },
  {
    image: strangeParadise4,
    imageSm: strangeParadise4Sm,
    title: "Strange Paradise IV",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2022/2023",
    alt: "Strange Paradise IV. Oil & acrylic on linen. 152cm x 152cm. 2022/2023",
  },
  {
    image: chelseaNyc,
    imageSm: chelseaNycSm,
    title: "Chelsea NYC",
    description: "Oil & acrylic on linen. 101cm x 101cm. 2023",
    alt: "Chelsea NYC. Oil & acrylic on linen. 101cm x 101cm. 2023",
  },
  {
    image: soho2053,
    imageSm: soho2053Sm,
    title: "Soho 2053",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2023",
    alt: "Soho 2053. Oil & acrylic on linen. 152cm x 152cm. 2023",
  },
  {
    image: thredbo4,
    imageSm: thredbo4Sm,
    title: "Thredbo IV",
    description: "Oil & acrylic on linen. 137cm x 152cm. 2023",
    alt: "Thredbo IV. Oil & acrylic on linen. 137cm x 152cm. 2023",
  },
  {
    image: newYorkersSpring,
    imageSm: newYorkersSpringSm,
    title: "New Yorkers- Spring",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2023",
    alt: "New Yorkers- Spring. Oil & acrylic on linen. 71cm x 71cm. 2023",
  },
  {
    image: newYorkersSummer,
    imageSm: newYorkersSummerSm,
    title: "New Yorkers- Summer",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2023",
    alt: "New Yorkers- Summer. Oil & acrylic on linen. 152cm x 152cm. 2023",
  },
  {
    image: newYorkersFall,
    imageSm: newYorkersFallSm,
    title: "New Yorkers- Fall",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2023",
    alt: "New Yorkers- Fall. Oil & acrylic on linen. 71cm x 71cm. 2023",
  },
  {
    image: newYorkersWinter,
    imageSm: newYorkersWinterSm,
    title: "New Yorkers- Winter",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2023",
    alt: "New Yorkers- Winter. Oil & acrylic on linen. 152cm x 152cm. 2023",
  },
  {
    image: redfern,
    imageSm: redfernSm,
    title: "East Redfern",
    description: "Oil & acrylic on linen. 61cm x 71cm. 2021",
    alt: "East Redfern. Oil & acrylic on linen. 61cm x 71cm. 2021",
  },
  {
    image: manly3,
    imageSm: manly3Sm,
    title: "Manly III",
    description: "Oil & Acrylic on linen. 137cm X 152cm. 2021",
    alt: "Manly III. Oil & Acrylic on linen. 137cm X 152cm. 2021",
  },
  {
    image: theInterview6,
    imageSm: theInterview6Sm,
    title: "The Interview VI",
    description: "Oil & Acrylic on linen. 84cm X 84cm. 2019",
    alt: "The Interview VI. Oil & Acrylic on linen. 84cm X 84cm. 2019",
  },
  {
    image: theInterviewDetail,
    imageSm: theInterviewDetailSm,
    title: "The Interview VI (detail)",
    description: "Oil & Acrylic on linen. 84cm X 84cm. 2019",
    alt: "(detail) The Interview VI. Oil & Acrylic on linen. 84cm X 84cm. 2019",
  },
  {
    image: campCove,
    imageSm: campCoveSm,
    title: "Camp Cove IV & IV(15 minutes later)",
    description: "Oil & acrylic on linen. 61cm x 71cm(each). 2021",
    alt: "Camp Cove IV. Oil & acrylic on linen. 61cm x 71cm. 2021",
  },
  {
    image: woollahra2,
    imageSm: woollahra2Sm,
    title: "A Day in Woollahra II",
    description: "Oil & acrylic on linen. 76cm x 76cm. 2022",
    alt: "A Day in Woollahra II. Oil & acrylic on linen. 76cm x 76cm. 2022",
  },
  {
    image: paddo,
    imageSm: paddoSm,
    title: "Paddington V",
    description: "Oil & Acrylic on linen. 137cm X 152cm. 2020",
    alt: "Paddington V. Oil & Acrylic on linen. 137cm X 152cm. 2020",
  },
  {
    image: october,
    imageSm: octoberSm,
    title: "October",
    description: "Oil & Acrylic on linen. 150cm X 150cm. 2022",
    alt: "October. Oil & Acrylic on linen. 150cm X 150cm. 2022",
  },
  {
    image: mtBuller,
    imageSm: mtBullerSm,
    title: "Mt Buller",
    description: "Oil & Acrylic on linen. 91cm X 122cm. 2020",
    alt: "Mt Buller. Oil & Acrylic on linen. 91cm X 122cm. 2020",
  },
  {
    image: justHangingAround,
    imageSm: justHangingAroundSm,
    title: "New Yorkers- Just Hanging Around",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2023",
    alt: "New Yorkers- Just Hanging Around. Oil & acrylic on linen. 152cm x 152cm. 2023",
  },
  {
    image: overcast,
    imageSm: overcastSm,
    title: "Overcast",
    description: "Oil & Acrylic on linen. 137cm X 152cm. 2022",
    alt: "Overcast. Oil & Acrylic on linen. 137cm X 152cm. 2022",
  },
  {
    image: springStreet,
    imageSm: springStreetSm,
    title: "Spring St",
    description: "Oil & Acrylic on linen. 41cm X 35.5cm. 2023",
    alt: "Spring St. Oil & Acrylic on linen. 41cm X 35.5cm. 2023",
  },
  {
    image: jazzInPark2,
    imageSm: jazzInPark2Sm,
    title: "Jazz in the Park II",
    description: "Oil & acrylic on linen. 61cm x 61cm. 2018",
    alt: "Jazz in the Park II. Oil & acrylic on linen. 61cm x 61cm. 2018",
  },
  {
    image: strangeParadise3,
    imageSm: strangeParadise3Sm,
    title: "Strange Paradise III",
    description: "Oil & Acrylic on linen. 150cm X 150cm. 2022",
    alt: "Strange Paradise III. Oil & Acrylic on linen. 150cm X 150cm. 2022",
  },
  {
    image: theRestaurant,
    imageSm: theRestaurantSm,
    title: "The Restaurant",
    description: "Oil & acrylic on linen. 61cm x 71cm. 2022",
    alt: "The Restaurant. Oil & acrylic on linen. 61cm x 71cm. 2022",
  },
  {
    image: richmond,
    imageSm: richmondSm,
    title: "Richmond",
    description: "Oil & Acrylic on linen. 152cm X 152cm. 2021",
    alt: "Richmond. Oil & Acrylic on linen. 152cm X 152cm. 2021",
  },
  {
    image: thredbo,
    imageSm: thredboSm,
    title: "Thredbo III",
    description: "Oil & acrylic on linen. 61cm x 61cm. 2022",
    alt: "Thredbo III. Oil & acrylic on linen. 61cm x 61cm. 2022",
  },
  {
    image: paris,
    imageSm: parisSm,
    title: "Paris",
    description: "Oil & Acrylic on linen. 51cm X 51cm. 2018",
    alt: "Paris. Oil & Acrylic on linen. 51cm X 51cm. 2018",
  },
  {
    image: pinkAfternoon,
    imageSm: pinkAfternoonSm,
    title: "Pink Afternoon IV- Bronte Beach",
    description: "Oil & Acrylic on linen. 56cm X 66cm. 2018",
    alt: "Pink Afternoon IV- Bronte Beach. Oil & Acrylic on linen. 56cm X 66cm. 2018",
  },
  {
    image: marbleArch,
    imageSm: marbleArchSm,
    title: "Marble Arch",
    description: "Oil & Acrylic on canvas. 61cm X 61cm. 2018",
    alt: "Marble Arch. Oil & Acrylic on canvas. 61cm X 61cm. 2018",
  },
  {
    image: hamsteadHeath,
    imageSm: hamsteadHeathSm,
    title: "Hampstead Heath",
    description: "Oil & Acrylic on canvas. 61cm X 61cm. 2018",
    alt: "Hampstead Heath. Oil & Acrylic on canvas. 61cm X 61cm. 2018",
  },
  {
    image: ottawa,
    imageSm: ottawaSm,
    title: "Rideau Canal- Ottawa",
    description: "Oil & acrylic on linen. 137cm x 152cm. 2021",
    alt: "Rideau Canal- Ottawa. Oil & acrylic on linen. 137cm x 152cm. 2021",
  },
  {
    image: bondiSummers7,
    imageSm: bondiSummers7Sm,
    title: "Bondi Summers VII",
    description: "Oil & Acrylic on linen. 137cm X 152cm. 2020",
    alt: "Bondi Summers VII. Oil & Acrylic on linen. 137cm X 152cm. 2020",
  },
  {
    image: aDayInAnnadale,
    imageSm: aDayInAnnadaleSm,
    title: "A Day in Annandale",
    description: "Oil & Acrylic on linen. 137cm X 152cm. 2018",
    alt: "A Day in Annandale. Oil & Acrylic on linen. 137cm X 152cm. 2018",
  },
  {
    image: eastVillage,
    imageSm: eastVillageSm,
    title: "Monday Afternoon- East Village",
    description: "Oil & Acrylic on canvas. 61cm X 61cm. 2018",
    alt: "Monday Afternoon- East Village. Oil & Acrylic on canvas. 61cm X 61cm. 2018",
  },
  {
    image: newYorkJune,
    imageSm: newYorkJuneSm,
    title: "Summer Morning, New York",
    description: "Oil & acrylic on linen. 152cm x 152cm. 2023",
    alt: "Summer Morning, New York. Oil & acrylic on linen. 152cm x 152cm. 2023",
  },
  {
    image: kuttiBeach2,
    imageSm: kuttiBeach2Sm,
    title: "Kutti Beach II",
    description: "Oil & acrylic on linen. 61cm x 71cm. 2021",
    alt: "Kutti Beach II. Oil & acrylic on linen. 61cm x 71cm. 2021",
  },
  {
    image: manly2,
    imageSm: manly2Sm,
    title: "Manly 2",
    description: "Oil & Acrylic on linen. 61cm X 61cm. 2019",
    alt: "Manly 2. Oil & Acrylic on linen. 61cm X 61cm. 2019",
  },
  {
    image: campCoveDetail,
    imageSm: campCoveDetailSm,
    title: "Camp Cove III(Detail)",
    description: "Oil & Acrylic on linen. 30.5cm X 30.5cm. 2019",
    alt: "Camp Cove III(Detail). Oil & Acrylic on linen. 30.5cm X 30.5cm. 2019",
  },
  {
    image: surryHills,
    imageSm: surryHillsSm,
    title: "Surry Hills",
    description: "Oil & acrylic on linen. 137cm x 152cm. 2021",
    alt: "Surry Hills. Oil & acrylic on linen. 137cm x 152cm. 2021",
  },
  {
    image: castingCall,
    imageSm: castingCallSm,
    title: "Casting Call",
    description: "Oil & Acrylic on canvas. 36cm X 41cm. 2018",
    alt: "Casting Call. Oil & Acrylic on canvas. 36cm X 41cm. 2018",
  },
  {
    image: protestsDowntown,
    imageSm: protestsDowntownSm,
    title: "Clown on Wall Street",
    description: "Oil & acrylic on canvas. 61cm x 61cm. 2018",
    alt: "Clown on Wall Street. Oil & acrylic on canvas. 61cm x 61cm. 2018",
  },
  {
    image: theFilmSet,
    imageSm: theFilmSetSm,
    title: "The Film Set",
    description: "Oil & Acrylic on canvas. 41cm X 36cm. 2018",
    alt: "The Film Set. Oil & Acrylic on canvas. 41cm X 36cm. 2018",
  },
  {
    image: moonlightBeach,
    imageSm: moonlightBeachSm,
    title: "Moonlight Beach & Cardiff State Beach",
    description: "Oil & Acrylic on linen. 91cm X 84cm. 2018",
    alt: "Moonlight Beach & Cardiff State Beach. Oil & Acrylic on linen. 91cm X 84cm. 2018",
  },
  {
    image: sydney4,
    imageSm: sydney4Sm,
    title: "Sydney IV",
    description: "Oil & acrylic on linen. 71cm x 92cm. 2021",
    alt: "Sydney IV. Oil & acrylic on linen. 71cm x 92cm. 2021",
  },
  {
    image: les,
    imageSm: lesSm,
    title: "New York in June- LES",
    description: "Oil & Acrylic on linen. 137cm X 152cm. 2020",
    alt: "New York in June- LES. Oil & Acrylic on linen. 137cm X 152cm. 2020",
  },
  {
    image: castingCall2,
    imageSm: castingCall2Sm,
    title: "Casting Call II",
    description: "Oil & Acrylic on linen. 84cm X 84cm. 2019",
    alt: "Casting Call II. Oil & Acrylic on linen. 84cm X 84cm. 2019",
  },
  {
    image: zermatt,
    imageSm: zermattSm,
    title: "Zermatt",
    description: "Oil & Acrylic on linen. 102cm X 168cm. 2019/2020",
    alt: "Zermatt. Oil & Acrylic on linen. 102cm X 168cm. 2019/2020",
  },
  {
    image: theInterview,
    imageSm: theInterviewSm,
    title: "The Interview V",
    description: "Oil & acrylic on canvas. 61cm X 61cm. 2018",
    alt: "The Interview V. Oil & Acrylic on canvas. 61cm X 61cm. 2018",
  },
  {
    image: theBusStop5,
    imageSm: theBusStop5Sm,
    title: "The Bus Stop V: La Nina Summer",
    description: "Oil & acrylic on linen. 152cm X 183cm. 2023",
    alt: "The Bus Stop V: La Nina Summer. Oil & acrylic on linen. 152cm X 183cm. 2023",
  },
  {
    image: burleighHeads,
    imageSm: burleighHeadsSm,
    title: "Burleigh Heads",
    description: "Oil & acrylic on linen. 76cm X 76cm. 2023",
    alt: "Burleigh Heads. Oil & acrylic on linen. 76cm X 76cm. 2023",
  },
  {
    image: northLondon,
    imageSm: northLondonSm,
    title: "Primrose Hill- London",
    description: "Oil & acrylic on linen. 71cm X 91cm. 2018",
    alt: "Primrose Hill- London. Oil & Acrylic on linen. 71cm X 91cm. 2018",
  },
  {
    image: summerHolidays,
    imageSm: summerHolidaysSm,
    title: "Summer Holidays III",
    description: "Oil & acrylic on linen. 91cm x 122cm. 2018",
    alt: "Summer Holidays III. Oil & acrylic on linen. 91cm x 122cm. 2018",
  },
  {
    image: forFiveLA,
    imageSm: forFiveLASm,
    title: "ForFive CoffeeShop",
    description: "333 S Grand Ave. Downtown Los Angeles. 2019",
    alt: "ForFive CoffeeShop- 333 S Grand Ave. Downtown Los Angeles. 2019",
  },
  {
    image: darlinghurst,
    imageSm: darlinghurstSm,
    title: "Darlinghurst",
    description: "Oil & Acrylic on linen. 102cm X 122cm. 2020",
    alt: "Darlinghurst. Oil & Acrylic on linen. 102cm X 122cm. 2020",
  },
  {
    image: cityOfAngels,
    imageSm: cityOfAngelsSm,
    title: "City of Angels",
    description: "Oil & acrylic on linen. 150cm x 150cm. 2022",
    alt: "City of Angels. Oil & acrylic on linen. 150cm x 150cm. 2022",
  },
  {
    image: theBusStop2,
    imageSm: theBusStop2Sm,
    title: "The Bus Stop II",
    description: "Oil & acrylic on canvas. 61cm x 61cm. 2018",
    alt: "The Bus Stop II. Oil & acrylic on canvas. 61cm x 61cm. 2018",
  },
  {
    image: greenpoint,
    imageSm: greenpointSm,
    title: "Greenpoint-Brooklyn & Greenwich Village-New York",
    description: "Each- Oil & acrylic on linen. 30.5cm x 30.5cm. 2020",
    alt: "Greenpoint-Brooklyn & Greenwich Village-New York",
  },
  {
    image: princeSt,
    imageSm: princeStSm,
    title: "Prince St",
    description: "Oil & Acrylic on linen. 22.5cm X 20cm. 2018",
    alt: "Prince St. Oil & Acrylic on linen. 22.5cm X 20cm. 2018",
  },
  {
    image: east69thSt,
    imageSm: east69thStSm,
    title: "East 69th St",
    description: "Oil & Acrylic on linen. 152cm X 137cm. 2019",
    alt: "East 69th St. Oil & Acrylic on linen. 152cm X 137cm. 2019",
  },
  {
    image: bondSt,
    imageSm: bondStSm,
    title: "Bond St",
    description: "Oil & acrylic on linen. 152cm x 137cm. 2019",
    alt: "Bond St. Oil & acrylic on linen. 152cm x 137cm. 2019",
  },
  {
    image: bondStDetail,
    imageSm: bondStDetailSm,
    title: "Bond St (Detail)",
    description: "Oil & acrylic on linen. 152cm x 137cm. 2019",
    alt: "Bond St (Detail). Oil & acrylic on linen. 152cm x 137cm. 2019",
  },
   {
    image: greeneSt,
    imageSm: greeneStSm,
    title: "Greene St",
    description: "Oil & acrylic on linen. 41cm x 36cm. 2023",
    alt: "Greene St. Oil & acrylic on linen. 41cm x 36cm. 2023",
  },
  {
    image: losAngeles,
    imageSm: losAngelesSm,
    title: "West Hollywood & Downtown LA",
    description: "(Each) Oil & Acrylic on linen. 84cm X 84cm. 2018",
    alt: "West Hollywood & Downtown LA",
  },
  {
    image: pointKint,
    imageSm: pointKintSm,
    title: "Point Roadkight Beach",
    description: "Oil & Acrylic on linen. 137cm X 152cm. 2019",
    alt: "Point Roadkight Beach. Oil & Acrylic on linen. 137cm X 152cm. 2019",
  },
  {
    image: fiDi2,
    imageSm: fiDi2Sm,
    title: "Financial District NYC- Spring",
    description: "Oil & Acrylic on linen. 84cm X 84cm. 2018",
    alt: "Financial District NYC- Spring. Oil & Acrylic on linen. (each) 84cm X 84cm. 2018",
  },
  {
    image: aDayinPaddo3,
    imageSm: aDayinPaddo3Sm,
    title: "A Day in Paddo III",
    description: "Oil & acrylic on linen. 61cm x 61cm. 2022",
    alt: "A Day in Paddo III. Oil & acrylic on linen. 61cm x 61cm. 2022",
  },
  {
    image: studio2019,
    imageSm: studio2019Sm,
    title: "Studio 2019",
    description: "Los Angeles paintings",
    alt: "Studio 2019",
  },
  {
    image: bondiIcebergs,
    imageSm: bondiIcebergsSm,
    title: "Bondi Icebergs",
    description: "Oil & Acrylic on linen. 30.5cm X 30.5cm. 2020",
    alt: "Bondi Icebergs. Oil & Acrylic on linen. 30.5cm X 30.5cm. 2020",
  },
  {
    image: sydney3,
    imageSm: sydney3Sm,
    title: "Sydney III",
    description: "Oil & acrylic on linen. 137cm X 152cm. 2020",
    alt: "Sydney III. Oil & acrylic on linen. 137cm X 152cm. 2020",
  },
  {
    image: cobbleHill,
    imageSm: cobbleHillSm,
    title: "Cobble Hill- Brooklyn",
    description: "Oil & acrylic on linen. 71cm X 71cm. 2023",
    alt: "Cobble Hill- Brooklyn. Oil & acrylic on linen. 71cm X 71cm. 2023",
  },
  {
    image: sandringhamBeach,
    imageSm: sandringhamBeachSm,
    title: "Sandringham Beach",
    description: "Oil & acrylic on linen. 61cm X 101cm. 2023",
    alt: "Sandringham Beach. Oil & acrylic on linen. 61cm X 101cm. 2023",
  },
  {
    image: tamarama,
    imageSm: tamaramaSm,
    title: "Tamarama",
    description: "Oil & acrylic on linen. 66cm x 56cm. 2018",
    alt: "Tamarama. Oil & acrylic on linen. 66cm x 56cm. 2018",
  },
  {
    image: paddington6,
    imageSm: paddington6Sm,
    title: "Paddington VI",
    description: "Oil & Acrylic on linen. 84cm x 84cm. 2020",
    alt: "Paddington VI. Oil & Acrylic on linen. 84cm x 84cm. 2020",
  },
  {
    image: aDayInChipenndale,
    imageSm: aDayInChipenndaleSm,
    title: "A Day in Chippendale",
    description: "Oil & Acrylic on canvas. 84cm X 84cm. 2020",
    alt: "A Day in Chippendale. Oil & Acrylic on canvas. 84cm X 84cm. 2020",
  },
  {
    image: snowDayWilliamsburg,
    imageSm: snowDayWilliamsburgSm,
    title: "Snow Day in Williamsburg",
    description: "Oil & Acrylic on canvas. 84cm X 84cm. 2020",
    alt: "Snow Day in Williamsburg. Oil & Acrylic on canvas. 84cm X 84cm. 2020",
  },
  {
    image: skiApres,
    imageSm: skiApresSm,
    title: "Après-ski",
    description: "Oil & acrylic on linen. 30.5cm x 30.5cm. 2022",
    alt: "Après-ski. Oil & acrylic on linen. 30.5cm x 30.5cm. 2022",
  },
  {
    image: sandyBay,
    imageSm: sandyBaySm,
    title: "Sandy Bay",
    description: "Oil & Acrylic on linen. 30.5cm X 30.5cm. 2020",
    alt: "Sandy Bay. Oil & Acrylic on linen. 30.5cm X 30.5cm. 2020",
  },
  {
    image: london,
    imageSm: londonSm,
    title: "North London- Angel to Highbury",
    description: "Oil & Acrylic on linen. 91cm X 122cm. 2019",
    alt: "North London- Angel to Highbury. Oil & Acrylic on linen. 91cm X 122cm. 2019",
  },
  {
    image: toorak,
    imageSm: toorakSm,
    title: "Toorak",
    description: "Oil & Acrylic on linen. 152cm X 152cm. 2021",
    alt: "Toorak. Oil & Acrylic on linen. 152cm X 152cm. 2021",
  },
  {
    image: aDayInWoolahra,
    imageSm: aDayInWoolahraSm,
    title: "A Day in Woollahra",
    description:
      "Oil & acrylic on linen. (Diptych) 56cm x 61cm each canvas. 2020",
    alt: "A Day in Woollahra. Oil & acrylic on linen. (Diptych) 56cm x 61cm each canvas. 2020",
  },
  {
    image: paddington4,
    imageSm: paddington4Sm,
    title: "Paddington IV",
    description: "Oil & acrylic on linen. 91cm x 112cm. 2018",
    alt: "Paddington IV. Oil & acrylic on linen. 91cm x 112cm. 2018",
  },
  {
    image: madisonAve,
    imageSm: madisonAveSm,
    title: "Madison Avenue- Upper East Side",
    description: "Oil & Acrylic on linen. 84cm x 84cm. 2020",
    alt: "Madison Avenue, Upper East Side. Oil & Acrylic on linen. 84cm x 84cm. 2020",
  },
  {
    image: theOptimist,
    imageSm: theOptimistSm,
    title: "The Optimist",
    description: "Oil & Acrylic on linen. 91cm X 102cm. 2020",
    alt: "The Optimist. Oil & Acrylic on linen. 91cm X 102cm. 2020",
  },
  {
    image: broadway,
    imageSm: broadwaySm,
    title: "Broadway",
    description: "Oil & acrylic on linen. 51cm x 46cm. 2022",
    alt: "Broadway. Oil & acrylic on linen. 51cm x 46cm. 2022",
  },
  {
    image: snowDayNYC,
    imageSm: snowDayNYCSm,
    title: "Snow Day in Soho",
    description: "Oil & acrylic on canvas. 137cm X 152cm. 2018",
    alt: "Snow Day in Soho. Oil & acrylic on canvas. 137cm X 152cm. 2018",
  },
  {
    image: bleeckerStStation,
    imageSm: bleeckerStStationSm,
    title: "Bleecker Street Station",
    description: "Oil & acrylic on board. 45cm x 55cm. 2018",
    alt: "Bleecker Street Station. Oil & acrylic on board. 45cm x 55cm. 2018",
  },
  {
    image: amsterdam,
    imageSm: amsterdamSm,
    title: "Oud-West Amsterdam",
    description: "Oil & acrylic on linen. 38cm X 41cm. 2019",
    alt: "Oud-West Amsterdam. Oil & acrylic on linen. 38cm X 41cm. 2019",
  },
  {
    image: paddington7,
    imageSm: paddington7Sm,
    title: "Paddington VII",
    description: "Oil & acrylic on linen. 137cm X 152cm. 2021",
    alt: "Paddington VII. Oil & acrylic on linen. 137cm X 152cm. 2021",
  },
  {
    image: betootaHeights,
    imageSm: betootaHeightsSm,
    title: "Betoota Heights",
    description: "Oil & acrylic on linen. 61cm x 71cm. 2022",
    alt: "Betoota Heights. Oil & acrylic on linen. 61cm x 71cm. 2022",
  },
  {
    image: bronte,
    imageSm: bronteSm,
    title: "Twins at Bronte Beach II",
    description: "Oil & acrylic on linen. 84cm X 84cm. 2020",
    alt: "Twins at Bronte Beach II. Oil & acrylic on linen. 84cm X 84cm. 2020",
  },
  {
    image: washingtonDC,
    imageSm: washingtonDCSm,
    title: "DC/Virgina",
    description: "Oil & acrylic on linen. 137cm X 152cm. 2019",
    alt: "DC/Virgina. Oil & acrylic on linen. 137cm X 152cm. 2019",
  },
  {
    image: familyVacation3,
    imageSm: familyVacation3Sm,
    title: "Family Vacation III",
    description: "Oil & acrylic on linen. 92cm x 84cm. 2017-2019",
    alt: "Family Vacation III. Oil & acrylic on linen. 92cm x 84cm. 2017-2019",
  },
  {
    image: middlePark,
    imageSm: middleParkSm,
    title: "Middle Park- Melbourne",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2017-2018",
    alt: "Middle Park- Melbourne. Oil & acrylic on linen. 71cm x 71cm. 2017-2018",
  },
   {
    image: prospectPark,
    imageSm: prospectParkSm,
    title: "Prospect Avenue- Brooklyn",
    description: "Oil & acrylic on linen. 71cm x 71cm. 2023",
    alt: "Prospect Avenue- Brooklyn. Oil & acrylic on linen. 71cm x 71cm. 2023",
  },
];

export default peopleScapes2023Collection;
